module.exports = __webpack_public_path__ + "img/combo.7c082f88.png";